export default defineNuxtPlugin(async (nuxtApp) => {
  window.ms_initSentryPlugins = (event) => nuxtApp.$sentryService.initPlugins(event)

  document.addEventListener('scroll', window.ms_initSentryPlugins)
  document.addEventListener('mousemove', window.ms_initSentryPlugins)
  document.addEventListener('touchstart', window.ms_initSentryPlugins)
})
